import deepmerge from 'deepmerge'
import * as C from '@/consts'

/**
 * 組織情報の初期値
 */
export const init = {
  code: '',
  name: '',

  traits: {
    needLicense: C.NEED_LICENSE_NONE,
    needAuth: 0,
    optins: false,
    paymentMethods: [],
    paymentApi: null,
    emailDomain: ''
  },

  agreements: [],

  masters: {
    carCategories: [],
    carTypes: []
  },

  theme: {
    favicon: '',
    dark: false,
    colors: {},
    navs: [],
    links: []
  },

  loginTo: null
}

export default deepmerge(init, {})
